import React from "react";

export const ApplicationContext = React.createContext();